module.exports = __webpack_public_path__ + "media/images/flags/hn-2926a9cbcf9cb75f72272b6970c973ff.svg";